import React from "react";
import { motion } from "framer-motion";

export const Section = ({ children, className = "", id }) => (
  <section id={id} className={`py-24 md:py-36 px-6 md:px-10 ${className}`}>
    <div className="max-w-[1440px] mx-auto">{children}</div>
  </section>
);

export const Eyebrow = ({ children, className = "" }) => (
  <p className={`overline text-muted-foreground ${className}`}>{children}</p>
);

export const Reveal = ({ children, delay = 0, y = 24, className = "" }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.9, delay, ease: [0.2, 0.7, 0.2, 1] }}
    className={className}
  >
    {children}
  </motion.div>
);

export const StaggerList = ({ children, className = "" }) => (
  <motion.div
    initial="hidden"
    whileInView="show"
    viewport={{ once: true, margin: "-80px" }}
    variants={{ hidden: {}, show: { transition: { staggerChildren: 0.08 } } }}
    className={className}
  >
    {children}
  </motion.div>
);

export const StaggerItem = ({ children, className = "" }) => (
  <motion.div
    variants={{
      hidden: { opacity: 0, y: 24 },
      show: { opacity: 1, y: 0, transition: { duration: 0.8, ease: [0.2, 0.7, 0.2, 1] } },
    }}
    className={className}
  >
    {children}
  </motion.div>
);

export const Divider = ({ label }) => (
  <div className="flex items-center gap-4">
    <span className="h-px flex-1 bg-border" />
    {label && <span className="overline text-muted-foreground">{label}</span>}
    <span className="h-px flex-1 bg-border" />
  </div>
);
